// extracted by mini-css-extract-plugin
export default {"carousel":"ProductCarouselComponentMobile_carousel__TDFUo"};